import React, { useState } from 'react';
import { Play, Pause } from 'react-ionicons';
import { useDispatch, useSelector } from 'react-redux';
import * as localForage from 'localforage';
import {
  filterRecents,
  setRecentsTo,
  updateCurrentPlayingStation,
  updateTimeStampOnStationList,
} from '../../store/features/stationSlice';
import {
  updateStation,
  togglePlayingState,
  setFirstLoad,
  setIsBuffering,
  setOldStationTo,
} from '../../store/features/playerSlice';
import { Avatar } from './Avatar';
import displayStationInitials from '../../utils/functions/displayInitials';

const AvatarContainer = ({ station, showIcons = true, width = null }) => {
  let { Name, IsPlaying } = station;

  const dispatch = useDispatch();

  const recentStorage = localForage.createInstance({
    name: 'recent',
  });

  const { currentStation, oldStation } = useSelector((state) => state.player);

  const [isHovered, setIsHovered] = useState(false);

  const displayPlayingIcons = () =>
    IsPlaying ||
    (currentStation.Id === station.Id && currentStation.IsPlaying) ? (
      <Pause
        height={width ? '55px' : '43px'}
        width={width ? '55px' : '43px'}
        color="#003876"
        style={{ paddingTop: '8px', paddingRight: '1px', zIndex: 100000 }}
      />
    ) : (
      <Play
        height={width ? '55px' : '43px'}
        width={width ? '55px' : '43px'}
        color="#003876"
        style={{ paddingTop: '7px', paddingLeft: '3px', zIndex: 100000 }}
      />
    );

  const addToStorageRecents = async (stationToSave) => {
    if (station.IsPlaying) {
      return;
    }

    let SavedStation = Object.assign({}, stationToSave);
    SavedStation.LastListened = Date.now();

    let data = (await recentStorage.getItem('recents')) ?? [];

    data.forEach((station, index) => {
      if (typeof station != 'undefined') {
        if (SavedStation?.Id === station?.Id) {
          data.splice(index, 1);
        }
      }
    });
    data.unshift(SavedStation);
    data.length = 4;

    await recentStorage.setItem('recents', data);
    data = (await recentStorage.getItem('recents')) ?? [];
    dispatch(setRecentsTo(data));
  };

  const avatarHover = () => setIsHovered(true);
  const avatarNotHover = () => setIsHovered(false);

  const onClickHandler = async () => {
    if (showIcons === false) return;

    if (oldStation.Id !== currentStation.Id || oldStation.Id !== station.Id) {
      dispatch(setOldStationTo(currentStation));
      dispatch(setIsBuffering(true));
    }

    await addToStorageRecents(station);
    dispatch(updateCurrentPlayingStation(station));
    dispatch(updateStation(station));
    dispatch(togglePlayingState());
    dispatch(updateTimeStampOnStationList(station));
    dispatch(filterRecents());
    dispatch(setFirstLoad(false));
  };

  return (
    <Avatar
      style={{
        minHeight: width ?? '58px',
        minWidth: width ?? '58px',
        fontSize: '1.65rem',
        borderWidth: '3px',
        zIndex: 100000,
      }}
      onClick={onClickHandler}
      onMouseEnter={avatarHover}
      onMouseLeave={avatarNotHover}>
      {isHovered && showIcons
        ? displayPlayingIcons()
        : displayStationInitials(Name) ?? 'NA'}
    </Avatar>
  );
};

export default AvatarContainer;
